import { render, staticRenderFns } from "./ReportSpecialist.vue?vue&type=template&id=60423158&scoped=true&"
import script from "./ReportSpecialist.vue?vue&type=script&lang=js&"
export * from "./ReportSpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60423158",
  null
  
)

export default component.exports